import { PlusOutlined } from '@ant-design/icons'
import { useState } from 'react'
import type { Control, FieldErrors } from 'react-hook-form'

import AtomButton from '@/components/Atoms/AtomButton/AtomButton'
import AtomSelect from '@/components/Atoms/AtomSelect/AtomSelect'
import HoverElement from '@/components/Atoms/HoverElement/HoverElement'
import type { StoreCreationFormType } from '@/components/EntityCreationModals/StoreCreationModal/StoreCreationModal.config'
import type { OptionType, SelectFormControlType } from '@/types'

import type { SupplierCreationFormType } from '../SupplierCreationModal.config'
import SupplierNewStoreForm from '../SupplierNewStoreForm/SupplierNewStoreForm'
import cn from './SupplierStoresField.module.scss'

type SupplierStoresFieldProps = {
  control: Control<SupplierCreationFormType>
  errors: FieldErrors<SupplierCreationFormType>
  options: OptionType[]
  isOrganisationSelected: boolean
  onAddStore: (values: StoreCreationFormType) => void
}

function SupplierStoresField({
  control,
  errors,
  options,
  isOrganisationSelected,
  onAddStore,
}: SupplierStoresFieldProps) {
  const [newStoreOpen, setNewStoreOpen] = useState(false)

  return (
    <div className={cn.storesField}>
      <HoverElement>
        <AtomSelect
          layout="stacked"
          fullWidth
          showSearch
          mode="multiple"
          openByHover={false}
          isOrganisationSelected={isOrganisationSelected}
          title="Склады"
          placeholder="Выберите склады поставщика"
          options={options}
          formName="stores"
          formErrors={errors}
          formControl={control as SelectFormControlType}
        />
      </HoverElement>
      {newStoreOpen ? (
        <SupplierNewStoreForm
          isOrganisationSelected={isOrganisationSelected}
          onCancel={() => setNewStoreOpen(false)}
          onAdd={(values) => {
            onAddStore(values)
            setNewStoreOpen(false)
          }}
        />
      ) : (
        <AtomButton
          variant="secondary"
          icon={<PlusOutlined />}
          className={cn.createButton}
          onClick={() => setNewStoreOpen(true)}
        >
          Создать новый склад
        </AtomButton>
      )}
    </div>
  )
}

export default SupplierStoresField
